import * as drawerTypes from '../types/drawerTypes';

export const applyScanMode = (scanMode) => {
    return {
        type: drawerTypes.APPLY_SCAN_MODE,
        payload: scanMode
    }
};